import styles from "./shift-records-details-force-close-modal.module.scss";
import { locale } from "localization/en";
import { Text, TextField } from "components/commons";
import { ConfirmModal } from "components/modals";
import { useEffect, useState } from "react";

const ForceCloseShiftModal = ({
  readOnly = false,
  remarks = "",
  loading = false,
  onSubmit,
  ...modal
}) => {
  const [textValue, setTextValue] = useState("");

  useEffect(() => {
    if (modal.active) {
      setTextValue(readOnly ? remarks || "" : "");
    }
  }, [modal.active, readOnly, remarks]);

  const handleInputChange = (name, value) => {
    setTextValue(value.value);
  };

  const handleForceClose = () => {
    onSubmit?.(textValue.trim());
  };

  return (
    <ConfirmModal
      {...modal}
      title={locale.forceCloseShift}
      content={readOnly ? "" : locale.forceCloseSyncWarning}
      contentStyle={styles.content}
      hideSecondary={readOnly}
      primary={{
        text: readOnly ? locale.gotIt : locale.forceClose,
        disabled: !readOnly && textValue.trim().length === 0,
        loading,
        onClick: readOnly ? () => modal.close() : handleForceClose,
      }}
      secondary={{
        text: locale.cancel,
        onClick: () => modal.close(),
      }}
    >
      <div className={styles.form}>
        <Text className={styles.label}>{locale.remarks}</Text>
        <TextField
          multiline
          placeholder={locale.typeYourRemarks}
          maxLength={200}
          readOnly={readOnly}
          value={textValue}
          onChange={handleInputChange}
        />
      </div>
    </ConfirmModal>
  );
};

export default ForceCloseShiftModal;
